import { TestRunHandler } from './testRunHandler';
import type { RunnerOptions } from './runOptions';
import type { TestRunStatus } from './testRunStatus';

export class ExecutionQueue {
    private _waitingTests: TestRunHandler[];
    public pendingAppUploads = new Map<string, { isUploaded: boolean; uploadedAppId: string }>();

    constructor(executionId: string, executionName: string, testList: any[], options: RunnerOptions, branchToUse: string, testStatus: TestRunStatus) {
        const appIds = new Set(testList.map(t => t.nativeApp?.appId).filter(Boolean));
        if (!options.appId && appIds.size > 1) {
            appIds.forEach(appId => {
                this.pendingAppUploads.set(appId, { isUploaded: false, uploadedAppId: '' });
            });
        }
        if (options.appId) {
            this.pendingAppUploads.set(options.appId, { isUploaded: false, uploadedAppId: '' });
        }
        this._waitingTests = testList.map(testInfo => new TestRunHandler(executionId, executionName, testInfo, options, branchToUse, testStatus));
    }

    public stop() {
        this._waitingTests = [];
    }

    public getNext() {
        const nextTestRunHandler = this._waitingTests.shift();
        if (nextTestRunHandler) {
            return nextTestRunHandler;
        }
        return undefined;
    }

    public hasMoreTests() {
        return Boolean(this._waitingTests.length);
    }
}
